import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Home from './containers/Home/Home';
import Hub from './containers/Hub/Hub';
import Watchlist from './containers/Watchlist/Watchlist';
import PhysicalMovieCollection from './containers/PhysicalMovieCollection/PhysicalMovieCollection';
import PhysicalGameCollection from './containers/PhysicalGameCollection/PhysicalGameCollection';
import GameList from './containers/GameList/GameList';
import TVShows from './containers/TVShows/TVShows';
import Comics from './containers/Comics/Comics';
import MediaLists from './containers/MediaLists/MediaLists';
import AuthRoute from './components/AuthRoute';
import Login from './components/Login';
import { ROUTES } from './constants';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, () => setLoading(false));
    return () => unsubscribe();
  }, []);

  if (loading)
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );

  return (
    <Router>
      <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route
          path={ROUTES.hub}
          element={
            <AuthRoute>
              <Hub />
            </AuthRoute>
          }
        />
        {/* Public PWA landing page — desktop visitors are redirected to /hub */}
        <Route path={ROUTES.mediaLists} element={<MediaLists />} />
        {/* Watchlist is PUBLIC — read-only for visitors, editable for the owner */}
        <Route path={ROUTES.watchlist} element={<Watchlist />} />
        {/* TV Shows is public too: visitors can look, only the owner can tick */}
        <Route path={ROUTES.tvShows} element={<TVShows />} />
        {/* Comic Shelf is public too: visitors browse, only the owner edits.
            One route for the shelf and its section pages keeps it mounted. */}
        <Route path={`${ROUTES.comicShelf}/*`} element={<Comics />} />
        {/* Its old address, for bookmarks and the home-screen app */}
        <Route path="/comics/*" element={<Navigate to={ROUTES.comicShelf} replace />} />
        <Route
          path={ROUTES.physicalMovieCollection}
          element={
            <AuthRoute>
              <PhysicalMovieCollection />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.physicalGameCollection}
          element={
            <AuthRoute>
              <PhysicalGameCollection />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.gameList}
          element={
            <AuthRoute>
              <GameList />
            </AuthRoute>
          }
        />
        <Route path={ROUTES.login} element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;